import _slicedToArray from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { MISSIONS_COUNTER } from '../../../screens/Missions/constants';
import { hasCurrentMissionBattles, hasRewardState, hasSomeCompleteState } from '../../../screens/Missions/utils/missionsPerformance';
import handlerMissionProgress from '../index';
import PushNotification from '../../../lib/notifications/PushNotification';
import Utils from '../../../utils';
import { TYPEOF } from '../../../constants';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentProgress } from '../../../state/slices/missions/missions';
import { useLazyGetBattlesAndMissionsQuery } from '../../../state/query/unifiedQuerys/battlesMissions';
var EXCLUDED_COUNTER_TYPES = new Set([MISSIONS_COUNTER.COLLECT_BONUS_X_TIMES, MISSIONS_COUNTER.LEVEL_UP_X_TIMES]);
var isFunction = function isFunction(param) {
  return typeof param === TYPEOF.FUNCTION;
};
var compoundFloor = function compoundFloor(p1, hasSecondary, p2) {
  var fp1 = Math.floor(p1);
  if (!hasSecondary) return fp1;
  var fp2 = Math.floor(p2 !== null && p2 !== void 0 ? p2 : 0);
  return Math.floor((fp1 + fp2) / 2);
};
var tsSig = function tsSig(evs) {
  var _evs$createdTimestamp;
  return Array.isArray(evs) ? evs.map(function (e) {
    var _e$createdTimestamp;
    return (_e$createdTimestamp = e === null || e === void 0 ? void 0 : e.createdTimestamp) !== null && _e$createdTimestamp !== void 0 ? _e$createdTimestamp : '';
  }).join('|') : (_evs$createdTimestamp = evs === null || evs === void 0 ? void 0 : evs.createdTimestamp) !== null && _evs$createdTimestamp !== void 0 ? _evs$createdTimestamp : '';
};
var useMissionsProgress = function useMissionsProgress(props) {
  var lastSpinEvents = props.lastSpinEvents,
    currentMission = props.currentMission,
    timedBonus = props.timedBonus,
    isMissionsScreen = props.isMissionsScreen;
  var missionGameId = currentMission.missionGameId,
    _currentMission$count = currentMission.counterType,
    counterType = _currentMission$count === void 0 ? null : _currentMission$count,
    counterGoal = currentMission.counterGoal,
    counterReachdedValue = currentMission.counterReachdedValue,
    secondaryCounterReachdedValue = currentMission.secondaryCounterReachdedValue,
    serverProgress = currentMission.serverProgress,
    clientProgress = currentMission.clientProgress,
    missionStatus = currentMission.missionStatus,
    missionType = currentMission.missionType,
    _currentMission$secon = currentMission.secondaryCounterType,
    secondaryCounterType = _currentMission$secon === void 0 ? null : _currentMission$secon,
    _currentMission$secon2 = currentMission.secondaryCounterGoal,
    secondaryCounterGoal = _currentMission$secon2 === void 0 ? null : _currentMission$secon2;
  var dispatch = useDispatch();
  var _useLazyGetBattlesAnd = useLazyGetBattlesAndMissionsQuery(),
    _useLazyGetBattlesAnd2 = _slicedToArray(_useLazyGetBattlesAnd, 1),
    trigger = _useLazyGetBattlesAnd2[0];
  var level = useSelector(function (state) {
    return state.levelInfo.level;
  });
  var clientMissionCompletePercent = useRef(0);
  var primaryPctRef = useRef(0);
  var secondaryPctRef = useRef(0);
  var isInRewardState = useMemo(function () {
    return hasRewardState(missionStatus);
  }, [missionStatus]);
  var battlesRunning = useMemo(function () {
    return hasCurrentMissionBattles(missionType);
  }, [missionType]);
  var isWeb = useMemo(function () {
    return Utils.isWebOrMobileWeb();
  }, []);
  var missionKey = useMemo(function () {
    return [counterType, secondaryCounterType || '', missionGameId || '', counterGoal || '', secondaryCounterGoal || ''].join('|');
  }, [counterType, secondaryCounterType, missionGameId, counterGoal, secondaryCounterGoal]);
  useEffect(function () {
    var base = Number.isFinite(serverProgress) && Number.isFinite(clientProgress) ? Math.max(Math.floor(serverProgress), Math.floor(clientProgress)) : Number.isFinite(serverProgress) ? Math.floor(serverProgress) : Math.floor(clientProgress !== null && clientProgress !== void 0 ? clientProgress : 0);
    var checkStartExtraPercentage = function checkStartExtraPercentage(reachedValue, finalGoal) {
      if (reachedValue > 0 && finalGoal) {
        var number = reachedValue / finalGoal * 100;
        var decimalPart = number - Math.floor(number);
        return decimalPart;
      }
      return 0;
    };

    // this will add primary extra percentage like 0.75 to the base
    var extra_primary = checkStartExtraPercentage(counterReachdedValue, counterGoal);
    // this will add secondary extra percentage like 0.75 to the base
    var extra_secondary = checkStartExtraPercentage(secondaryCounterReachdedValue, secondaryCounterGoal);
    if (secondaryCounterType && secondaryCounterGoal) {
      primaryPctRef.current = base + extra_primary;
      secondaryPctRef.current = base + extra_secondary;
    } else {
      primaryPctRef.current = base + extra_primary;
      secondaryPctRef.current = 0;
    }
    dispatch(setCurrentProgress(base));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [missionKey]);
  var handleNewProgress = useCallback(function (percentage) {
    var checked = (clientMissionCompletePercent === null || clientMissionCompletePercent === void 0 ? void 0 : clientMissionCompletePercent.current) || percentage;
    if (Math.floor(checked) >= 100 && !isInRewardState) {
      clientMissionCompletePercent.current = checked;
      setTimeout(function () {
        trigger({
          requestAssetsData: false
        });
      }, 2000);
    } else {
      dispatch(setCurrentProgress(isInRewardState ? 100 : percentage));
    }
  }, [trigger, dispatch, isInRewardState]);
  useEffect(function () {
    if (isInRewardState && serverProgress >= 100) {
      clientMissionCompletePercent.current = 0;
      dispatch(setCurrentProgress(100));
    }
  }, [serverProgress, isInRewardState, dispatch]);
  var hasSecondary = !!(secondaryCounterType && secondaryCounterGoal);
  var applyEvent = useCallback(function (event) {
    if (EXCLUDED_COUNTER_TYPES.has(counterType)) return;
    var primaryHandler = handlerMissionProgress[counterType];
    primaryPctRef.current = isFunction(primaryHandler) ? primaryHandler(event, counterGoal, primaryPctRef.current, missionGameId) : primaryPctRef.current;
    var secondaryHandler = handlerMissionProgress[secondaryCounterType];
    secondaryPctRef.current = isFunction(secondaryHandler) ? secondaryHandler(event, secondaryCounterGoal, secondaryPctRef.current, missionGameId) : secondaryPctRef.current;
  }, [counterType, counterGoal, missionGameId, secondaryCounterGoal, secondaryCounterType]);
  var handleSpinEvent = useCallback(function () {
    if (!lastSpinEvents) return;
    var evts = Array.isArray(lastSpinEvents) ? lastSpinEvents.slice() : [lastSpinEvents];
    evts.sort(function (a, b) {
      var _a$createdTimestamp, _b$createdTimestamp;
      var ta = +new Date((_a$createdTimestamp = a === null || a === void 0 ? void 0 : a.createdTimestamp) !== null && _a$createdTimestamp !== void 0 ? _a$createdTimestamp : 0);
      var tb = +new Date((_b$createdTimestamp = b === null || b === void 0 ? void 0 : b.createdTimestamp) !== null && _b$createdTimestamp !== void 0 ? _b$createdTimestamp : 0);
      return ta - tb;
    });
    var _iterator = _createForOfIteratorHelper(evts),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var ev = _step.value;
        applyEvent(ev);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var finalProgress = compoundFloor(primaryPctRef.current, hasSecondary, secondaryPctRef.current);
    handleNewProgress(finalProgress);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastSpinEvents, applyEvent, hasSecondary, handleNewProgress]);
  useEffect(function () {
    handleSpinEvent();
    return function () {
      clientMissionCompletePercent.current = 0;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tsSig(lastSpinEvents)]);
  useEffect(function () {
    if (counterType === MISSIONS_COUNTER.COLLECT_BONUS_X_TIMES && timedBonus !== null && timedBonus !== void 0 && timedBonus.success) handleNewProgress(serverProgress);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timedBonus]);
  useEffect(function () {
    if (counterType === MISSIONS_COUNTER.LEVEL_UP_X_TIMES && level > 1) handleNewProgress(serverProgress);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [level]);
  useEffect(function () {
    if (Math.round(clientProgress) < Math.round(serverProgress)) dispatch(setCurrentProgress(serverProgress));
  }, [clientProgress, dispatch, serverProgress]);
  useEffect(function () {
    if (!isWeb && serverProgress >= 100) PushNotification.cancelMissionReminderNotification();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serverProgress]);
  var isCollectStatus = useMemo(function () {
    var isMissionComplete = serverProgress === 100 && !isMissionsScreen;
    var isBattleComplete = battlesRunning && hasSomeCompleteState(missionStatus);
    return isMissionComplete || isBattleComplete;
  }, [serverProgress, isMissionsScreen, battlesRunning, missionStatus]);
  return {
    clientProgress: clientProgress,
    serverProgress: serverProgress,
    isCollectStatus: isCollectStatus,
    battlesRunning: battlesRunning
  };
};
export default useMissionsProgress;